import { RightOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Input, message, Popconfirm, Row, Select } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";

const currencyOptions = [
  { label: "United Arab Emirates Dirham (AED) ", value: "AED" },
  { label: "Argentine Peso (ARS) ", value: "ARS" },
  { label: "Australian Dollar (AUD A$) ", value: "AUD" },
  { label: "Bulgarian Lev (BGN) ", value: "BGN" },
  { label: "Bolivian Boliviano (BOB) ", value: "BOB" },
  { label: "Canadian Dollar (CAD CA$) ", value: "CAD" },
  { label: "Swiss Franc (CHF) ", value: "CHF" },
  { label: "Chilean Peso (CLP) ", value: "CLP" },
  { label: "Chinese Yuan (CNY CN¥) ", value: "CNY" },
  { label: "Colombian Peso (COP) ", value: "COP" },
  { label: "Czech Koruna (CZK) ", value: "CZK" },
  { label: "Danish Krone (DKK) ", value: "DKK" },
  { label: "Egyptian Pound (EGP) ", value: "EGP" },
  { label: "Euro (EUR €) ", value: "EUR" },
  { label: "British Pound (GBP £) ", value: "GBP" },
  { label: "Hong Kong Dollar (HKD HK$) ", value: "HKD" },
  { label: "Hungarian Forint (HUF) ", value: "HUF" },
  { label: "Indonesian Rupiah (IDR) ", value: "IDR" },
  { label: "Israeli New Shekel (ILS ₪) ", value: "ILS" },
  { label: "Japanese Yen (JPY ¥) ", value: "JPY" },
  { label: "South Korean Won (KRW ₩) ", value: "KRW" },
  { label: "Moroccan Dirham (MAD) ", value: "MAD" },
  { label: "Mexican Peso (MXN MX$) ", value: "MXN" },
  { label: "Malaysian Ringgit (MYR) ", value: "MYR" },
  { label: "Norwegian Krone (NOK) ", value: "NOK" },
  { label: "New Zealand Dollar (NZD NZ$) ", value: "NZD" },
  { label: "Peruvian Sol (PEN) ", value: "PEN" },
  { label: "Philippine Peso (PHP ₱) ", value: "PHP" },
  { label: "Pakistani Rupee (PKR) ", value: "PKR" },
  { label: "Polish Zloty (PLN) ", value: "PLN" },
  { label: "Romanian Leu (RON) ", value: "RON" },
  { label: "Serbian Dinar (RSD) ", value: "RSD" },
  { label: "Saudi Riyal (SAR) ", value: "SAR" },
  { label: "Swedish Krona (SEK) ", value: "SEK" },
  { label: "Singapore Dollar (SGD) ", value: "SGD" },
  { label: "Thai Baht (THB) ", value: "THB" },
  { label: "Turkish Lira (TRY) ", value: "TRY" },
  { label: "New Taiwan Dollar (TWD NT$) ", value: "TWD" },
  { label: "Ukrainian Hryvnia (UAH) ", value: "UAH" },
  { label: "US Dollar (USD $) ", value: "USD" },
  { label: "Vietnamese Dong (VND ₫) ", value: "VND" },
  { label: "South African Rand (ZAR) ", value: "ZAR" },
]
const countryOptions = [
  { label: "Afghanistan", value: "AF", timezone: "Asia/Kabul" },
  { label: "Quần đảo Aland", value: "AX", timezone: "Europe/Mariehamn" },
  { label: "Albania", value: "AL", timezone: "Europe/Tirane" },
  { label: "Algeria", value: "DZ", timezone: "Africa/Algiers" },
  { label: "American Samoa", value: "AS", timezone: "Pacific/Pago_Pago" },
  { label: "Andorra", value: "AD", timezone: "Europe/Andorra" },
  { label: "Angola", value: "AO", timezone: "Africa/Luanda" },
  { label: "Anguilla", value: "AI", timezone: "America/Anguilla" },
  { label: "Nam Cực", value: "AQ", timezone: "Antarctica/Palmer" },
  { label: "Antigua và Barbuda", value: "AG", timezone: "America/Antigua" },
  { label: "Argentina", value: "AR", timezone: "America/Argentina/Buenos_Aires" },
  { label: "Armenia", value: "AM", timezone: "Asia/Yerevan" },
  { label: "Aruba", value: "AW", timezone: "America/Aruba" },
  { label: "Châu Úc", value: "AU", timezone: "Australia/Sydney" },
  { label: "Áo", value: "AT", timezone: "Europe/Vienna" },
  { label: "Azerbaijan", value: "AZ", timezone: "Asia/Baku" },
  { label: "Bahamas", value: "BS", timezone: "America/Nassau" },
  { label: "Bahrain", value: "BH", timezone: "Asia/Bahrain" },
  { label: "Bangladesh", value: "BD", timezone: "Asia/Dhaka" },
  { label: "Barbados", value: "BB", timezone: "America/Barbados" },
  { label: "Belarus", value: "BY", timezone: "Europe/Minsk" },
  { label: "Nước Bỉ", value: "BE", timezone: "Europe/Brussels" },
  { label: "Belize", value: "BZ", timezone: "America/Belize" },
  { label: "Bénin", value: "BJ", timezone: "Africa/Porto-Novo" },
  { label: "Bermuda", value: "BM", timezone: "Atlantic/Bermuda" },
  { label: "Bhutan", value: "BT", timezone: "Asia/Thimphu" },
  { label: "Cộng hòa Bolivia của", value: "BO", timezone: "America/La_Paz" },
  { label: "Bonaire, Sint Eustatius và Saba", value: "BQ", timezone: "America/Kralendijk" },
  { label: "Bosnia và Herzegovina", value: "BA", timezone: "Europe/Sarajevo" },
  { label: "Botswana", value: "BW", timezone: "Africa/Gaborone" },
  { label: "Đảo Bouvet", value: "BV", timezone: "America/New_York" },
  { label: "Brazil", value: "BR", timezone: "America/Sao_Paulo" },
  { label: "Lãnh thổ Anh tại Ấn Độ Dương", value: "IO", timezone: "Indian/Chagos" },
  { label: "Vương quốc Bru-nây", value: "BN", timezone: "Asia/Brunei" },
  { label: "Bulgaria", value: "BG", timezone: "Europe/Sofia" },
  { label: "Burkina Faso", value: "BF", timezone: "Africa/Ouagadougou" },
  { label: "Burundi", value: "BI", timezone: "Africa/Bujumbura" },
  { label: "Campuchia", value: "KH", timezone: "Asia/Phnom_Penh" },
  { label: "Cameroon", value: "CM", timezone: "Africa/Douala" },
  { label: "Canada", value: "CA", timezone: "America/Toronto" },
  { label: "Cape Verde", value: "CV", timezone: "Atlantic/Cape_Verde" },
  { label: "Quần đảo Cayman", value: "KY", timezone: "America/Cayman" },
  { label: "Cộng hòa trung phi", value: "CF", timezone: "Africa/Bangui" },
  { label: "Cá hồng", value: "TD", timezone: "Africa/Ndjamena" },
  { label: "Chile", value: "CL", timezone: "Pacific/Easter" },
  { label: "Trung Quốc", value: "CN", timezone: "Asia/Shanghai" },
  { label: "Đảo christmas", value: "CX", timezone: "Indian/Christmas" },
  { label: "Quần đảo Cocos (Keeling)", value: "CC", timezone: "Indian/Cocos" },
  { label: "Colombia", value: "CO", timezone: "America/Bogota" },
  { label: "Comoros", value: "KM", timezone: "Indian/Comoro" },
  { label: "Congo", value: "CG", timezone: "Africa/Brazzaville" },
  { label: "Congo, Cộng hòa Dân chủ", value: "CD", timezone: "Africa/Kinshasa" },
  { label: "Quần đảo cook", value: "CK", timezone: "Pacific/Rarotonga" },
  { label: "Costa Rica", value: "CR", timezone: "America/Costa_Rica" },
  { label: "Croatia", value: "HR", timezone: "Europe/Zagreb" },
  { label: "Rượu cam bì", value: "CW", timezone: "America/Curacao" },
  { label: "Cộng Hòa Síp", value: "CY", timezone: "Asia/Nicosia" },
  { label: "Cộng Hòa Séc", value: "CZ", timezone: "Europe/Prague" },
  { label: "Đan mạch", value: "DK", timezone: "Europe/Copenhagen" },
  { label: "Djibouti", value: "DJ", timezone: "Africa/Djibouti" },
  { label: "Dominica", value: "DM", timezone: "America/Dominica" },
  { label: "Cộng hòa Dominica", value: "DO", timezone: "America/Santo_Domingo" },
  { label: "Ecuador", value: "EC", timezone: "Pacific/Galapagos" },
  { label: "Ai Cập", value: "EG", timezone: "Africa/Cairo" },
  { label: "El Salvador", value: "SV", timezone: "America/El_Salvador" },
  { label: "Equatorial Guinea", value: "GQ", timezone: "Africa/Malabo" },
  { label: "Eritrea", value: "ER", timezone: "Africa/Asmara" },
  { label: "Estonia", value: "EE", timezone: "Europe/Tallinn" },
  { label: "Ethiopia", value: "ET", timezone: "Africa/Addis_Ababa" },
  { label: "Quần đảo Falkland (Malvinas)", value: "FK", timezone: "Atlantic/Stanley" },
  { label: "Quần đảo Faroe", value: "FO", timezone: "Atlantic/Faroe" },
  { label: "Fiji", value: "FJ", timezone: "Pacific/Fiji" },
  { label: "Phần Lan", value: "FI", timezone: "Europe/Helsinki" },
  { label: "Pháp", value: "FR", timezone: "Europe/Paris" },
  { label: "Guiana thuộc Pháp", value: "GF", timezone: "America/Cayenne" },
  { label: "French Polynesia", value: "PF", timezone: "Pacific/Tahiti" },
  { label: "Lãnh thổ phía Nam của Pháp", value: "TF", timezone: "Indian/Kerguelen" },
  { label: "Gabon", value: "GA", timezone: "Africa/Libreville" },
  { label: "Gambia", value: "GM", timezone: "Africa/Banjul" },
  { label: "Georgia", value: "GE", timezone: "Asia/Tbilisi" },
  { label: "Nước Đức", value: "DE", timezone: "Europe/Berlin" },
  { label: "Ghana", value: "GH", timezone: "Africa/Accra" },
  { label: "Gibraltar", value: "GI", timezone: "Europe/Gibraltar" },
  { label: "Hy lạp", value: "GR", timezone: "Europe/Athens" },
  { label: "Greenland", value: "GL", timezone: "America/Thule" },
  { label: "Grenada", value: "GD", timezone: "America/Grenada" },
  { label: "Guadeloupe", value: "GP", timezone: "America/Guadeloupe" },
  { label: "Guam", value: "GU", timezone: "Pacific/Guam" },
  { label: "Guatemala", value: "GT", timezone: "America/Guatemala" },
  { label: "Guernsey", value: "GG", timezone: "Europe/Guernsey" },
  { label: "Guinea", value: "GN", timezone: "Africa/Conakry" },
  { label: "Guinea-Bissau", value: "GW", timezone: "Africa/Bissau" },
  { label: "Guyana", value: "GY", timezone: "America/Guyana" },
  { label: "Haiti", value: "HT", timezone: "America/Port-au-Prince" },
  { label: "Đảo Heard và quần đảo McDonald", value: "HM", timezone: "America/New_York" },
  { label: "Tòa Thánh (Vatican City State)", value: "VA", timezone: "Europe/Vatican" },
  { label: "Honduras", value: "HN", timezone: "America/Tegucigalpa" },
  { label: "Hồng Kông", value: "HK", timezone: "Asia/Hong_Kong" },
  { label: "Hungary", value: "HU", timezone: "Europe/Budapest" },
  { label: "Iceland", value: "IS", timezone: "Atlantic/Reykjavik" },
  { label: "Ấn Độ", value: "IN", timezone: "Asia/Kolkata" },
  { label: "Indonesia", value: "ID", timezone: "Asia/Jakarta" },
  { label: "Iraq", value: "IQ", timezone: "Asia/Baghdad" },
  { label: "Ireland", value: "IE", timezone: "Europe/Dublin" },
  { label: "Isle of Man", value: "IM", timezone: "Europe/Isle_of_Man" },
  { label: "Israel", value: "IL", timezone: "Asia/Jerusalem" },
  { label: "Italy", value: "IT", timezone: "Europe/Rome" },
  { label: "Jamaica", value: "JM", timezone: "America/Jamaica" },
  { label: "Nhật Bản", value: "JP", timezone: "Asia/Tokyo" },
  { label: "Áo nịt len", value: "JE", timezone: "Europe/Jersey" },
  { label: "Jordan", value: "JO", timezone: "Asia/Amman" },
  { label: "Kazakhstan", value: "KZ", timezone: "Asia/Almaty" },
  { label: "Kenya", value: "KE", timezone: "Africa/Nairobi" },
  { label: "Kiribati", value: "KI", timezone: "Pacific/Tarawa" },
  { label: "Cộng hòa Hàn Quốc", value: "KR", timezone: "Asia/Seoul" },
  { label: "Kuwait", value: "KW", timezone: "Asia/Kuwait" },
  { label: "Kyrgyzstan", value: "KG", timezone: "Asia/Bishkek" },
  { label: "Cộng hòa Dân chủ nhân dân Lào", value: "LA", timezone: "Asia/Vientiane" },
  { label: "Latvia", value: "LV", timezone: "Europe/Riga" },
  { label: "Lebanon", value: "LB", timezone: "Asia/Beirut" },
  { label: "Lesotho", value: "LS", timezone: "Africa/Maseru" },
  { label: "Liberia", value: "LR", timezone: "Africa/Monrovia" },
  { label: "Libya", value: "LY", timezone: "Africa/Tripoli" },
  { label: "Liechtenstein", value: "LI", timezone: "Europe/Vaduz" },
  { label: "Lithuania", value: "LT", timezone: "Europe/Vilnius" },
  { label: "Luxembourg", value: "LU", timezone: "Europe/Luxembourg" },
  { label: "Macao", value: "MO", timezone: "Asia/Macau" },
  { label: "Madagascar", value: "MG", timezone: "Indian/Antananarivo" },
  { label: "Malawi", value: "MW", timezone: "Africa/Blantyre" },
  { label: "Malaysia", value: "MY", timezone: "Asia/Kuala_Lumpur" },
  { label: "Maldives", value: "MV", timezone: "Indian/Maldives" },
  { label: "Mali", value: "ML", timezone: "Africa/Bamako" },
  { label: "Malta", value: "MT", timezone: "Europe/Malta" },
  { label: "Đảo Marshall", value: "MH", timezone: "Pacific/Majuro" },
  { label: "Martinique", value: "MQ", timezone: "America/Martinique" },
  { label: "Mauritania", value: "MR", timezone: "Africa/Nouakchott" },
  { label: "Mauritius", value: "MU", timezone: "Indian/Mauritius" },
  { label: "Mayotte", value: "YT", timezone: "Indian/Mayotte" },
  { label: "Mexico", value: "MX", timezone: "America/Tijuana" },
  { label: "Micronesia (liên bang của)", value: "FM", timezone: "Pacific/Chuuk" },
  { label: "Cộng hòa Moldova", value: "MD", timezone: "Europe/Chisinau" },
  { label: "Monaco", value: "MC", timezone: "Europe/Monaco" },
  { label: "Mông Cổ", value: "MN", timezone: "Asia/Hovd" },
  { label: "Montenegro", value: "ME", timezone: "Europe/Podgorica" },
  { label: "Montserrat", value: "MS", timezone: "America/Montserrat" },
  { label: "Morocco", value: "MA", timezone: "Africa/Casablanca" },
  { label: "Mozambique", value: "MZ", timezone: "Africa/Maputo" },
  { label: "Myanmar", value: "MM", timezone: "Asia/Yangon" },
  { label: "Namibia", value: "NA", timezone: "Africa/Windhoek" },
  { label: "Nauru", value: "NR", timezone: "Pacific/Nauru" },
  { label: "Nepal", value: "NP", timezone: "Asia/Kathmandu" },
  { label: "Nước Hà Lan", value: "NL", timezone: "Europe/Amsterdam" },
  { label: "New Caledonia", value: "NC", timezone: "Pacific/Noumea" },
  { label: "New Zealand", value: "NZ", timezone: "Pacific/Auckland" },
  { label: "Nicaragua", value: "NI", timezone: "America/Managua" },
  { label: "Niger", value: "NE", timezone: "Africa/Niamey" },
  { label: "Nigeria", value: "NG", timezone: "Africa/Lagos" },
  { label: "Niue", value: "NU", timezone: "Pacific/Niue" },
  { label: "Đảo Norfolk", value: "NF", timezone: "Pacific/Norfolk" },
  { label: "Bắc Macedonia", value: "MK", timezone: "Europe/Skopje" },
  { label: "Quần đảo Bắc Mariana", value: "MP", timezone: "Pacific/Saipan" },
  { label: "Na Uy", value: "NO", timezone: "Europe/Oslo" },
  { label: "Oman", value: "OM", timezone: "Asia/Muscat" },
  { label: "Pakistan", value: "PK", timezone: "Asia/Karachi" },
  { label: "Palau", value: "PW", timezone: "Pacific/Palau" },
  { label: "Palestine, Nhà nước", value: "PS", timezone: "Asia/Hebron" },
  { label: "Panama", value: "PA", timezone: "America/Panama" },
  { label: "Papua New Guinea", value: "PG", timezone: "Pacific/Port_Moresby" },
  { label: "Paraguay", value: "PY", timezone: "America/Asuncion" },
  { label: "Peru", value: "PE", timezone: "America/Lima" },
  { label: "Philippines", value: "PH", timezone: "Asia/Manila" },
  { label: "Pitcairn", value: "PN", timezone: "Pacific/Pitcairn" },
  { label: "Ba Lan", value: "PL", timezone: "Europe/Warsaw" },
  { label: "Bồ Đào Nha", value: "PT", timezone: "Atlantic/Azores" },
  { label: "Puerto Rico", value: "PR", timezone: "America/Puerto_Rico" },
  { label: "Qatar", value: "QA", timezone: "Asia/Qatar" },
  { label: "Sum họp", value: "RE", timezone: "Indian/Reunion" },
  { label: "Romania", value: "RO", timezone: "Europe/Bucharest" },
  { label: "Liên bang Nga", value: "RU", timezone: "Europe/Moscow" },
  { label: "Rwanda", value: "RW", timezone: "Africa/Kigali" },
  { label: "Saint Barthélemy", value: "BL", timezone: "America/St_Barthelemy" },
  { label: "Saint Helena, Ascension và Tristan da Cunha", value: "SH", timezone: "Atlantic/St_Helena" },
  { label: "Saint Kitts và Nevis", value: "KN", timezone: "America/St_Kitts" },
  { label: "Saint Lucia", value: "LC", timezone: "America/St_Lucia" },
  { label: "Saint Martin (Pháp một phần)", value: "MF", timezone: "America/Marigot" },
  { label: "Saint Pierre và Miquelon", value: "PM", timezone: "America/Miquelon" },
  { label: "Saint Vincent và Grenadines", value: "VC", timezone: "America/St_Vincent" },
  { label: "Samoa", value: "WS", timezone: "Pacific/Apia" },
  { label: "San Marino", value: "SM", timezone: "Europe/San_Marino" },
  { label: "Ả Rập Saudi", value: "SA", timezone: "Asia/Riyadh" },
  { label: "Senegal", value: "SN", timezone: "Africa/Dakar" },
  { label: "Serbia", value: "RS", timezone: "Europe/Belgrade" },
  { label: "Seychelles", value: "SC", timezone: "Indian/Mahe" },
  { label: "Sierra Leone", value: "SL", timezone: "Africa/Freetown" },
  { label: "Singapore", value: "SG", timezone: "Asia/Singapore" },
  { label: "Sint Maarten (Hà Lan một phần)", value: "SX", timezone: "America/Lower_Princes" },
  { label: "Slovakia", value: "SK", timezone: "Europe/Bratislava" },
  { label: "Slovenia", value: "SI", timezone: "Europe/Ljubljana" },
  { label: "Quần đảo Solomon", value: "SB", timezone: "Pacific/Guadalcanal" },
  { label: "Somalia", value: "SO", timezone: "Africa/Mogadishu" },
  { label: "Nam Phi", value: "ZA", timezone: "Africa/Johannesburg" },
  { label: "Quần đảo Nam Georgia và Nam Sandwich", value: "GS", timezone: "Atlantic/South_Georgia" },
  { label: "Phía nam Sudan", value: "SS", timezone: "Africa/Juba" },
  { label: "Tây Ban Nha", value: "ES", timezone: "Atlantic/Canary" },
  { label: "Sri Lanka", value: "LK", timezone: "Asia/Colombo" },
  { label: "Suriname", value: "SR", timezone: "America/Paramaribo" },
  { label: "Sudan", value: "SD", timezone: "Africa/Khartoum" },
  { label: "Svalbard và Jan Mayen", value: "SJ", timezone: "Arctic/Longyearbyen" },
  { label: "Thụy Điển", value: "SE", timezone: "Europe/Stockholm" },
  { label: "Thụy Sĩ", value: "CH", timezone: "Europe/Zurich" },
  { label: "São Tomé và Príncipe", value: "ST", timezone: "Africa/Sao_Tome" },
  { label: "Đài Loan", value: "TW", timezone: "Asia/Taipei" },
  { label: "Tajikistan", value: "TJ", timezone: "Asia/Dushanbe" },
  { label: "Tanzania, United Republic of", value: "TZ", timezone: "Africa/Dar_es_Salaam" },
  { label: "Thái Lan", value: "TH", timezone: "Asia/Bangkok" },
  { label: "Đi", value: "TG", timezone: "Africa/Lome" },
  { label: "Tokelau", value: "TK", timezone: "Pacific/Fakaofo" },
  { label: "Tonga", value: "TO", timezone: "Pacific/Tongatapu" },
  { label: "Trinidad và Tobago", value: "TT", timezone: "America/Port_of_Spain" },
  { label: "Tunisia", value: "TN", timezone: "Africa/Tunis" },
  { label: "Thổ Nhĩ Kỳ", value: "TR", timezone: "Europe/Istanbul" },
  { label: "Turkmenistan", value: "TM", timezone: "Asia/Ashgabat" },
  { label: "Quần đảo Turks và Caicos", value: "TC", timezone: "America/Grand_Turk" },
  { label: "Tuvalu", value: "TV", timezone: "Pacific/Funafuti" },
  { label: "Uganda", value: "UG", timezone: "Africa/Kampala" },
  { label: "Ukraine", value: "UA", timezone: "Europe/Kyiv" },
  { label: "Các Tiểu Vương Quốc Ả Rập Thống Nhất", value: "AE", timezone: "Asia/Dubai" },
  { label: "Vương quốc Anh", value: "GB", timezone: "Europe/London" },
  { label: "Hoa Kỳ", value: "US", timezone: "America/New_York" },
  { label: "Các tiểu đảo xa của Hoa Kỳ", value: "UM", timezone: "Pacific/Midway" },
  { label: "Uruguay", value: "UY", timezone: "America/Montevideo" },
  { label: "Uzbekistan", value: "UZ", timezone: "Asia/Tashkent" },
  { label: "Vanuatu", value: "VU", timezone: "Pacific/Efate" },
  { label: "Venezuela", value: "VE", timezone: "America/Caracas" },
  { label: "Việt Nam", value: "VN", timezone: "Asia/Ho_Chi_Minh" },
  { label: "Quần đảo Virgin, Anh", value: "VG", timezone: "America/Tortola" },
  { label: "Quần đảo Virgin, Mỹ", value: "VI", timezone: "America/St_Thomas" },
  { label: "Wallis và Futuna", value: "WF", timezone: "Pacific/Wallis" },
  { label: "Phía tây Sahara", value: "EH", timezone: "Africa/El_Aaiun" },
  { label: "Yemen", value: "YE", timezone: "Asia/Aden" },
  { label: "Zambia", value: "ZM", timezone: "Africa/Lusaka" },
  { label: "Zimbabwe", value: "ZW", timezone: "Africa/Harare" }
];

export default function CreateAccInMCCFunction(props) {
  const [loading, setLoading] = useState(false);
  const [profileModel, setProfileModel] = useState(testProfile);
  const [messageApi, contextHolder] = message.useMessage();

  const [quantity, setQuantity] = useState('5');
  const [tabsNo, setTabsNo] = useState('5');
  const [country, setCountry] = useState("US");
  const [currency, setCurrency] = useState("USD");

  const [isMCC, setIsMCC] = useState(false);
  const [mccTargetURL, setMccTargetURL] = useState("");

  const create = async (profile) => {
    if (!mccTargetURL) {
      messageApi.error("Vui lòng nhập URL MCC Con");
      return;
    }
    const selectedCountry = Array.isArray(country) ? country[0] : country;
    const selectedCurrency = Array.isArray(currency) ? currency[0] : currency;

    if (!selectedCountry) {
      messageApi.error("Vui lòng chọn Quốc gia");
      return;
    }
    if (!selectedCurrency) {
      messageApi.error("Vui lòng chọn Tiền tệ");
      return;
    }
    if (!quantity) {
      messageApi.error("Vui lòng chọn Số lượng");
      return;
    }

    const selectedCountryOption = countryOptions.find(opt => opt.value === selectedCountry);
    const timezone = selectedCountryOption ? selectedCountryOption.timezone : 'America/New_York';

    messageApi.info(`Profile: ${profile.name} >>> Tạo TK ${isMCC ? ' MCC' : 'Con'} trong MCC: SL: ${quantity} - Tabs: ${tabsNo} - Quốc Gia: ${selectedCountry} - Tiền Tệ: ${selectedCurrency} - Múi giờ: ${timezone}`);
    let body = {
      profile: profile,
      quantity,
      tabsNo,
      mccTargetURL,
      country: selectedCountry,
      currency: selectedCurrency,
      timezone,
      isMCC
    };
    axios
      .post(`${API_HOST}/api/account/create-acct-in-mcc`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ create-acct-in-mcc ~ e:", e);
        messageApi.error(e.response.data);
      });
  };
  useEffect(() => {
    let quantity = localStorage.getItem('acct-mcc-quantity')
    if (quantity) {
      setQuantity(quantity)
    }
    let tabsNo = localStorage.getItem('acct-mcc-tabsNo')
    if (tabsNo) {
      setTabsNo(tabsNo)
    }
    let country = localStorage.getItem('acct-mcc-country')
    if (country) {
      setCountry(country)
    }
    let currency = localStorage.getItem('acct-mcc-currency')
    if (currency) {
      setCurrency(currency)
    }
  }, [])

  const onOpenChange = (open) => {
    if (open) {
      setLoading(true);
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          setLoading(false);
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          setLoading(false);
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ width: '500px' }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Tạo TK MCC/Con"
        description={
          <div style={{ width: '500px' }}>
            {profileModel?.errorMsg?.length > 0 && (
              <label style={{ color: "red", border: "1px solid red" }}>
                <strong>{profileModel?.errorMsg}</strong>
              </label>
            )}
            <div style={{ color: 'red', display: 'flex', gap: 5 }}>Note: Chọn MCC cần tạo TK <RightOutlined /> Bấm Tab Tài Khoản <RightOutlined /> Copy URL</div>
            <Row>
              <Col span={5}>
                <b>Tạo {isMCC ? 'MCC con' : 'TK con'}</b>
              </Col>
              <Col span={19}>
                <Checkbox checked={isMCC} onChange={e => {
                  setIsMCC(e.target.checked)
                }}></Checkbox>
              </Col>
              <Col span={5}>
                <b>URL MCC {isMCC ? 'Tổng' : 'Con'}:</b>
              </Col>
              <Col span={19}>
                <Input
                  style={{ width: 400 }}
                  placeholder="VD: https://ads.google.com/aw/accounts?ocid=8300789009&ascid=8300789..."
                  onChange={(e) => setMccTargetURL(e.target.value)}
                />
              </Col>
              <Col span={5}>
                <label>Quốc Gia: </label>
              </Col>
              <Col span={19}>
                <Select
                  mode={"multiple"}
                  maxCount={1}
                  value={country}
                  style={{ width: 250 }}
                  placeholder="Quốc Gia ..."
                  options={countryOptions}
                  filterOption={(input, option) =>
                    (option.label || '').toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => {
                    setCountry(value)
                    localStorage.setItem("acct-mcc-country", value);
                  }}
                />
              </Col>
              <Col span={5}>
                <label>Tiền Tệ: </label>
              </Col>
              <Col span={19}>
                <Select
                  mode={"multiple"}
                  maxCount={1}
                  value={currency}
                  style={{ width: 250 }}
                  placeholder="Chọn tiền tệ"
                  options={currencyOptions}
                  filterOption={(input, option) =>
                    (option.value || '').toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => {
                    setCurrency(value);
                    localStorage.setItem("acct-mcc-currency", value);
                  }}
                />
              </Col>
              <Col span={5}>
                <label>Số Lượng: </label>
              </Col>
              <Col span={19}>
                <Input
                  value={quantity}
                  type="number"
                  style={{ width: 60 }}
                  placeholder="Số Lượng ..."
                  onChange={(e) => {
                    setQuantity(e.target.value)
                    localStorage.setItem("acct-mcc-quantity", e.target.value);
                  }}
                />
              </Col>
              <Col span={5}>
                <label>Số Tabs: </label>
              </Col>
              <Col span={19}>
                <Input
                  value={tabsNo}
                  type="number"
                  style={{ width: 60 }}
                  placeholder="Số Tabs ..."
                  onChange={(e) => {
                    setTabsNo(e.target.value)
                    localStorage.setItem("acct-mcc-tabsNo", e.target.value);
                  }}
                />
              </Col>

            </Row>
          </div>
        }
        onConfirm={() => create(props.profile)}
      >
        <Button type="primary" style={{ color: 'white' }} loading={loading}>
          <b>Tạo TK con (MCC)</b>
        </Button>
      </Popconfirm>
    </>
  );
}
